module.exports = __webpack_public_path__ + "static/media/AtTheCross.71eb9bdb.jpg";